import { render, staticRenderFns } from "./MultiStepQuizV3Dialog.vue?vue&type=template&id=3525eca3&scoped=true&"
import script from "./MultiStepQuizV3Dialog.vue?vue&type=script&lang=js&"
export * from "./MultiStepQuizV3Dialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepQuizV3Dialog.vue?vue&type=style&index=0&id=3525eca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525eca3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTextField,VTooltip})
